import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'

// Authenticated Pages Here
import InterestSelector from '../../components/ui/InterestSelector/InterestSelector'
import SubscriptionCancellation from '../../components/ui/SubscriptionCancellation/SubscriptionCancellation'
import AuthenticatedDataFetcher from '../AuthenticatedDataFetcher'
import AuthenticatedAdminDashboard from './AdminDashboard/AuthenticatedAdminDashboardIndex'
import AuthenticatedDashboardIndex from './Dashboard/AuthenticatedDashboardIndex'
import AuthenticatedDemoIndex from './Demo/AuthenticatedDemoIndex'
import AuthenticatedJobSearchIndex from './JobSearch/AuthenticatedJobSearchIndex'
import AuthenticatedOutcomesIndex from './Outcomes/AuthenticatedOutcomesIndex'
import AuthenticatedPageNotFound from './AuthenticatedPageNotFound'
import AuthenticatedParentDashboard from './ParentDashboard/AuthenticatedParentDashboardIndex'
import AuthenticatedPersonalityAssessmentIndex from './PersonalityAssessment/AuthenticatedPersonalityAssessmentIndex'
import AuthenticatedRecreateSubscriptionIndex from './RecreateSubscription/AuthenticatedRecreateSubscriptionIndex'
import AuthenticatedResumeSearchIndex from './Search/AuthenticatedResumeSearchIndex'
import AuthenticatedTuitionIndex from './Tuition/AuthenticatedTuitionIndex'
import AuthenticatedUpdatePaymentIndex from './UpdatePayment/AuthenticatedUpdatePaymentIndex'
import AuthenticatedUserProfileIndex from './UserProfile/AuthenticatedUserProfileIndex'
import AuthenticatedAboutIndex from './About/AuthenticatedAboutIndex'
import { getFeedResults } from './Dashboard/feedDuck'
import withFeed from '../../utils/graphql/hocs/withFeed'
import withPersonalityType from '../../utils/graphql/hocs/withPersonalityAssessmentResult'

const AuthenticatedRoutes = ({ match, ...props }) => (
  <div>
    <AuthenticatedDataFetcher />
    <InterestSelector getFeedsData={getFeedResults} />
    <SubscriptionCancellation />
    <Switch>
      <Route exact path={`${match.url}/personality-assessment`}>
        <AuthenticatedPersonalityAssessmentIndex {...props} />
      </Route>
      <Route exact path={`${match.url}/dashboard`}>
        <AuthenticatedDashboardIndex {...props} />
      </Route>
      <Route exact path={`${match.url}/demo`} component={AuthenticatedDemoIndex} />
      <Route exact path={`${match.url}/profile`} component={AuthenticatedUserProfileIndex} />
      <Route exact path={`${match.url}/jobs`} component={AuthenticatedJobSearchIndex} />
      <Route exact path={`${match.url}/tuition`} component={AuthenticatedTuitionIndex} />
      <Route
        exact
        path={`${match.url}/recreate-subscription`}
        component={AuthenticatedRecreateSubscriptionIndex}
      />
      <Route exact path={`${match.url}/search`} component={AuthenticatedResumeSearchIndex} />
      <Route exact path={`${match.url}/parent`} component={AuthenticatedParentDashboard} />
      <Route exact path={`${match.url}/admin`} component={AuthenticatedAdminDashboard} />
      <Route
        exact
        path={`${match.url}/update-payment`}
        component={AuthenticatedUpdatePaymentIndex}
      />
      <Route exact path={`${match.url}/about`} component={AuthenticatedAboutIndex} />
      <Route exact path={`${match.url}/outcomes`} component={AuthenticatedOutcomesIndex} />
      <Route component={AuthenticatedPageNotFound} />
    </Switch>
  </div>
)

AuthenticatedRoutes.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
}

export default withFeed(withPersonalityType(AuthenticatedRoutes))



// WEBPACK FOOTER //
// ./src/routes/authenticated/AuthenticatedRoutes.js